<template>
	<div>
		<div class="head_box p_flex p_f_a p_f_b p_box small_hand" v-show="!isLogin">
			<div class="p_flex p_f_a" style="height: 100%;">
				<div class="head_logo"><img src="../../assets/img/1.9_透明底1.png" /></div>
				<div class="p_flex p_f_a type_size_16 p_m_l_140" style="height: 100%;">
					<span style="position: relative;height: 100%;line-height: 3.5;">
						公司介绍
						<span class="header_heng" v-if="headeIndex == 1"></span>
					</span>
					<span class="p_m_l_100" style="position: relative;height: 100%;line-height: 3.5;">
						产品介绍
						<span class="header_heng" v-if="headeIndex == 2"></span>
					</span>
				</div>
			</div>
			<div class="subject_color type_size_22">登录</div>
		</div>
		<div class="head_box p_flex p_f_a p_f_b p_box small_hand" v-show="isLogin">
			<div class="p_flex p_f_a">
				<div class="head_logo"><img src="../../assets/img/1.9_透明底1.png" /></div>
			</div>
			<div class="p_flex p_f_a">
				<div class="p_flex p_f_a">
					<i class="el-icon-bell"></i>
					<span class="type_size_16 p_m_l_10 p_m_r_10">消息</span>
					<el-badge type="danger" v-if="unreadTotal > 0" :value="unreadTotal" :max="99" class="item"></el-badge>
				</div>
				<div class="type_size_22 p_m_l_60" @click="goUser">{{ mssage }}</div>
				<div class="p_m_l_100 subject_color type_size_22" @click="dropOut">退出</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Homet',
	data() {
		return {
			unreadTotal: 0,
			headeIndex:1
		};
	},
	computed: {
		isLogin() {
			return this.$store.state.hasLogin;
		},
		mssage() {
			return this.$store.state.user.name;
		}
	},
	watch: {
		'$route.path': {
			immediate: true,
			handler(newVal, oldVal) {
				if (newVal == '/Homet') {
					this.getUnreadTotal();
				}
			}
		}
	},
	mounted() {
		var userInfo = JSON.parse(localStorage.getItem('user'));
		if (userInfo) {
			this.$store.state.hasLogin = true;
			this.$store.state.user = userInfo;
			this.getUnreadTotal();
		} else {
			this.$store.state.hasLogin = false;
		}
	},
	methods: {
		getUnreadTotal() {
			var api = '';
			var userType = JSON.parse(localStorage.getItem('userInfo'));
			if (userType == 1) {
				api = 'api_student/news_unread_total';
			} else {
				api = 'api_teacher/news_unread_total';
			}
			this.$request
				.ajax(this)
				.post(api)
				.then(res => {
					this.unreadTotal = res.data.number;
				});
		},

		dropOut() {
			this.$confirm('您确定退出吗？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(() => {
					this.$message({
						type: 'success',
						message: '退出成功!'
					});
					this.$store.commit('logout'); //退出登录清空vuex和存储信息
					this.$router.replace({ path: '/loginOne' }); //跳转至选择老师学生
					location.reload(); //页面刷新
				})
				.catch(() => {
					// this.$message({
					// 	type: 'info',
					// 	message: '已取消删除'
					// });
				});
		},
		goUser() {
			var userInfo = JSON.parse(localStorage.getItem('userInfo'));
			if (userInfo == 1) {
				this.$router.push('/Users');
			} else {
				this.$router.push('/User');
			}
		}
	}
};
</script>

<style lang="scss" scoped>
.header_heng {
	position: absolute;
	bottom: 0;
	left: 50%;
	transform: translateX(-50%);
	display: block;
	width: 80%;
	height: 2px;
	background-color: #00af63;
	margin: 0 auto;
}

.el-header > div {
	height: 100%;
}
.head_box {
	height: 100%;

}
.head_logo {
	width: 86px;
	height: 28px;
	// background-color: #007400;
}
.el-icon-bell {
	font-size: 22px;
}
>>> .el-badge__content--danger {
	background-color: #f1282e;
}
</style>



// WEBPACK FOOTER //
// src/components/head/head.vue